<app-coaching-intervals-editor [fullscreen]="true" />
